import React from "react";
import Image from "next/image";
import { WHY_PARTNER_DATA } from "@/constastants/TailSpendConstants";
import styles from "./TailSpendManagement.module.scss";

function TailSpendWhyPartner() {
  return (
    <div className={styles.whyPartner}>
      <div className={styles.whyPartnerBg} />
      <div className={styles.whyPartnerRadialGradient} />
      <div className={styles.whyPartnerContent}>
        <div className={styles.whyPartnerHeader}>
          <h2 className={styles.whyPartnerHeading}>
            Why Partner With Us for Tail Spend Management
          </h2>
          <p className={styles.whyPartnerSubtext}>
            Elchemy brings a dedicated, expert-led approach to managing tail
            spend, so your procurement team can focus on strategy, not
            firefighting.
          </p>
        </div>
        <div className={styles.whyPartnerGrid}>
          {WHY_PARTNER_DATA.map((item) => (
            <div key={item.id} className={styles.whyPartnerCard}>
              <div className={styles.whyPartnerIcon}>
                <Image
                  src={item.icon}
                  alt={item.title}
                  width={52}
                  height={52}
                />
              </div>
              <div className={styles.whyPartnerCardContent}>
                <p className={styles.whyPartnerCardTitle}>{item.title}</p>
                <p className={styles.whyPartnerCardDescription}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TailSpendWhyPartner;
